// import Flatpickr
import Flatpickr from 'stimulus-flatpickr'

// Import style for flatpickr
require("flatpickr/dist/flatpickr.css")

// import a theme (could be in your main CSS entry too...)
// require('flatpickr/dist/themes/light.css')
// require('flatpickr/dist/themes/dark.css')

// you can also import a translation file
import { Spanish } from 'flatpickr/dist/l10n/es.js'
Flatpickr.localize(Spanish); // default locale is now Spanish
// Flatpickr.setDefaults({
//     altInput: true,
//     altFormat: 'd/m/Y',
//     dateFormat: 'd/m/Y',
//     // locale: 'es', // Not working, use Flatpickr.localize(Spanish);
//     // allowInput: true,
// })

import { Application } from "stimulus"

const application = Application.start()

// Manually register Flatpickr as a stimulus controller
application.register('flatpickr', Flatpickr)